import React from 'react';
import CreatableSelect from 'react-select/creatable';

export default function SelectOptions({
  theme,
  disabled,
  options,
  setOptions,
  tagsSelected
}) {
  const handleChange = (value) => {
    setOptions(value);
  };

  return (
    <CreatableSelect
      className="react-select"
      classNamePrefix="select"
      name="callback-react-select"
      isMulti
      getOptionLabel={(e) => e.name}
      getOptionValue={(e) => e._id}
      options={options}
      onCreateOption={() => {}}
      onChange={handleChange}
      value={tagsSelected}
      theme={theme}
      isDisabled={disabled}
    />
  );
}
